import React from "react";
import { Controller } from "react-hook-form";
import { Input } from "./input";
import { FormItem, FormLabel, FormControl, FormMessage } from "./form";
import { DatePicker } from "./date-picker";

const FormField = ({
  label,
  name,
  type = "text",
  register,
  control,
  errors,
  classes = {},
  ...props
}) => {
  if (type === "date") {
    return (
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <FormItem className={classes.formItem}>
            <FormLabel className={classes.formLabel}>{label}</FormLabel>
            <FormControl>
              <DatePicker
                defaultDate={field.value || new Date()}
                onDateChange={field.onChange}
                classes={{ button: "w-full" }}
                {...props}
              />
            </FormControl>
            {errors[name] && (
              <FormMessage className="!mt-1 text-xs">
                {errors[name].message}
              </FormMessage>
            )}
          </FormItem>
        )}
      />
    );
  }

  return (
    <FormItem className={classes.formItem}>
      <FormLabel className={classes.formLabel}>{label}</FormLabel>
      <FormControl>
        <Input
          type={type}
          {...register(name, type === "number" ? { valueAsNumber: true } : {})}
          {...props}
        />
      </FormControl>
      {errors[name] && (
        <FormMessage className="!mt-1 text-xs">
          {errors[name].message}
        </FormMessage>
      )}
    </FormItem>
  );
};

export { FormField };
